const validator = {
  /**
   * Valida se um valor é do tipo Telefone
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    const regex = /^(?:(55\d{2})|\d{2})[2-6]\d{7}$/
    return regex.test(value)
  }
}

export default validator
